import type { SummaryCardConfig } from './SummaryCard';

export function getFloatBalanceSummaryCardConfig(
    floatBalance: number,
    isFloatBalanceLoading: boolean
): SummaryCardConfig[] {
    return [
        {
            label: 'Float Balance',
            value: `₹${floatBalance.toLocaleString('en-IN')}`,
            showPeriod: false,
            valueVariant: 'default',
            isLoading: isFloatBalanceLoading,
        },
    ];
}
